import { useState } from "react";

export const faqs = [
  {
    q: "How fast can I get a passport in Birmingham, AL?",
    a: "Through Fast Passport Center, expedited processing can be as fast as 24 hours depending on your eligibility and the processing option you select. Standard government processing through the Birmingham Main Post Office can take 2–6 months, especially during busy travel seasons. For UAB medical professionals with international conferences, Regions Bank executives with client meetings abroad, and Mountain Brook families with cruise reservations, that timeline is simply not viable.",
  },
  {
    q: "Can UAB medical residents get expedited passports for international rotations?",
    a: "Absolutely. UAB Hospital's global health program places doctors in clinics from Guatemala to Ghana, and medical residents frequently need passports renewed for last-minute conference invitations or international research presentations. We regularly process expedited renewals and new applications for UAB, Samford, and Birmingham-Southern students and faculty on compressed timelines.",
  },
  {
    q: "What if my passport expires before a business trip to London or Frankfurt?",
    a: "This is a common scenario for Birmingham's financial sector. Regions Bank executives, law firm partners, and corporate managers travel to Europe on short notice for mergers, regulatory meetings, and client emergencies. Standard mail-in renewal through a Birmingham post office typically takes 2–6 months — far too long. Expedited processing through a registered courier is the reliable solution.",
  },
  {
    q: "Where is the Birmingham passport acceptance facility?",
    a: "The Birmingham Main Post Office at 351 24th St N is the primary passport acceptance facility. Hours are Monday–Friday 9:00 AM–4:00 PM. The Hoover Post Office at 2255A Chapel Rd also accepts applications with photo service available. However, these facilities only accept applications — they do not process expedited or emergency requests.",
  },
  {
    q: "Can Hoover, Vestavia Hills, and Homewood residents use your services?",
    a: "Yes. All Birmingham metro communities including Hoover, Vestavia Hills, Homewood, Mountain Brook, Trussville, Pelham, Helena, Alabaster, and Gardendale are within our service area. Since we operate remotely, your location in the Birmingham metro does not affect processing speed. Ship your documents overnight and we handle the rest.",
  },
  {
    q: "How quickly can Birmingham-Shuttlesworth travelers receive an expedited passport?",
    a: "Birmingham-Shuttlesworth International Airport serves as a gateway to Cancun, Toronto, and seasonal European destinations. Most Birmingham metro clients receive their passports within 2–9 business days with our expedited service. For emergency situations with confirmed travel within 14 days, 24-hour processing may be available.",
  },
  {
    q: "Do I need to visit an office to use Fast Passport Center?",
    a: "No — most Birmingham travelers start online and ship their documents via overnight courier. There is no local Fast Passport Center office in Birmingham, but that is the point: you do not need one. Start your order online, follow the checklist, and ship your documents overnight from anywhere in the Birmingham metro area.",
  },
  {
    q: "What documents do I need for an expedited passport?",
    a: "Most applicants need: proof of U.S. citizenship (current or expired U.S. passport, birth certificate, or naturalization certificate), a government-issued photo ID, completed passport forms, and passport photos. We provide a personalized checklist after you start your order.",
  },
  {
    q: "Is Fast Passport Center an official government agency?",
    a: "No — Fast Passport Center is a private, approved and registered U.S. Department of State passport courier service. We are not a government agency. We work within the official passport system to provide expedited processing through reserved courier submission availability. As a registered courier, we offer rates typically 30–100% lower than FedEx, Staples, and other third-party resellers.",
  },
];

export default function BirminghamFAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-white py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Questions?</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Frequently Asked <span className="text-[#F6C344]">Questions</span>
          </h2>
          <p className="text-gray-500 text-base">
            Everything Birmingham and Central Alabama travelers ask us most often about expedited passport services.
          </p>
        </div>

        <div className="space-y-2">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-[#F7F8FA] rounded-lg border border-gray-200 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between gap-4 p-5 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
              >
                <span className="font-semibold text-[#1A365D] text-sm leading-snug">{faq.q}</span>
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#1A365D] flex-shrink-0">
                  <i
                    className={`text-white text-sm transition-transform duration-200 ${
                      openIndex === i ? "ri-subtract-line" : "ri-add-line"
                    }`}
                  ></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-5 pb-5">
                  <p className="text-gray-500 text-sm leading-relaxed border-t border-gray-200 pt-4">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <p className="text-gray-500 text-sm mb-4">Still have questions? Our team is here to help.</p>
          <a
            href="tel:8772530084"
            className="inline-flex items-center gap-2 bg-[#1A365D] hover:bg-[#0F2240] text-white font-semibold text-sm px-6 py-3 rounded-md transition-all whitespace-nowrap"
          >
            <i className="ri-phone-line"></i> Call 877-253-0084
          </a>
        </div>
      </div>
    </section>
  );
}